import { LocaleCode } from '../helpers';
import { Internal } from '../internal';

export enum CommonDictionariesEnum {
  cities = 'cities',
  countries = 'countries',
  currencies = 'currencies',
  durations = 'durations',
  employments = 'employments',
  englishLevels = 'englishLevels',
  experiences = 'experiences',
  mainSkills = 'mainSkills',
  regions = 'regions',
  skills = 'skills',
  softSkills = 'softSkills',
  sources = 'sources',
  specialities = 'specialities',
  vacancyStatuses = 'vacancyStatuses',
}
export enum PortalSpecificDictionariesEnum {
  departments = 'departments',
  recruiters = 'recruiters',
  organizations = 'organizations',
  securityGroups = 'securityGroups',
  businesses = 'businesses',
  vacancyCategories = 'vacancyCategories',
}
export enum PortalEditableDictionariesEnum {
  rejectReasons = 'rejectReasons',
  shortlistStatuses = 'shortlistStatuses',
  tags = 'tags',
  'mail-attachments' = 'mail-attachments',
  'mail-templates' = 'mail-templates',
}

export enum PortalNonEditableDictionariesEnum {
  'address-list' = 'address-list',
}

export enum CustomFieldsDictionaryEnum {
  'profile-fields' = 'profile-fields',
  'project-fields' = 'project-fields',
  'bid-statuses-fields' = 'bid-statuses-fields',
  'recruiter-fields' = 'recruiter-fields',
}

export enum AutocompleteDictionaryEnum {
  cities = 'cities',
  countries = 'countries',
  mainSkills = 'mainSkills',
  skills = 'skills',
  softSkills = 'softSkills',
  specialities = 'specialities',
  sources = 'sources',
  tags = 'tags',
}

export type DictionariesEnum =
  | CommonDictionariesEnum
  | PortalSpecificDictionariesEnum
  | PortalEditableDictionariesEnum
  | PortalNonEditableDictionariesEnum
  | CustomFieldsDictionaryEnum
  | AutocompleteDictionaryEnum;

export interface DictionarySkillSynonym
  extends Internal.Dictionary.Generic.Item {
  skill: DictionarySkill;
}

export interface DictionaryDepartment {
  children: string[];
  hasChildren: boolean;
  id: string;
  isActual: boolean;
  level: number;
  name: string;
  parentId: string | null;
  portalId: number;
}

export interface DictionarySkill extends Internal.Dictionary.Generic.Item {
  slug: string;
  softSkills: boolean;
  synonyms: Internal.Dictionary.Generic.Item[];
  synonymsAndTranslations: string[];
}

export type DictionaryShortListCodes =
  | 'custom'
  | 'k2_send_to_review'
  | 'long_list'
  | 'applies'
  | 'interview_planned'
  | 'sent_to_review'
  | 'not_accepted'
  | 'ai'
  | 'hired'
  | 'chat_bot_passed'
  | 'reserve';

export interface StaticDictionaryItem {
  id: number | string;
  translations: (Internal.Dictionary.Generic.Item & {
    locale: LocaleCode;
    full_name?: string;
  })[];
  route?: string;
}

export interface CustomForm {
  id: string;
  tabs: CustomDialogTab[];
  target: 'profileDialog' | 'vacancyDialog';
}
export interface CustomDialogTab {
  controls: CustomFormControl[];
  index: number;
  name: { [key in LocaleCode]: string };
}
export interface CustomFormControl {
  name: string;
  position: number;
  readonly?: boolean;
  width: string;
}
